import { render, staticRenderFns } from "./chemUpdateHistory.vue?vue&type=template&id=1345cfb4"
import script from "./chemUpdateHistory.vue?vue&type=script&lang=js"
export * from "./chemUpdateHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1345cfb4')) {
      api.createRecord('1345cfb4', component.options)
    } else {
      api.reload('1345cfb4', component.options)
    }
    module.hot.accept("./chemUpdateHistory.vue?vue&type=template&id=1345cfb4", function () {
      api.rerender('1345cfb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/form/chemUpdateHistory.vue"
export default component.exports